<template>
  <div class="container">
    <div class="mt-2 card">
      <PatientInfo v-if="patient_id != null" :patient_id="patient_id">
        <template v-slot:action-bt>
          <button
            @click="showCreatePatientService"
            class="mycustom-success-button"
          >
            Add Nursing Service
          </button>
        </template>
      </PatientInfo>
    </div>
  </div>
  <div v-if="loading">
    <loader />
  </div>
  <div v-if="!loading" class="container">
    <div class="mt-2 card">
      <table class="table align-items-center mb-0">
        <thead>
          <tr style="color: black">
            <th scope="col">Service Ref.Number</th>
            <th scope="col">Service Name</th>
            <th scope="col">Status</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="service in services" :key="service.id">
            <th scope="row">{{ service.id }}</th>
            <td style="color: black">{{ service.service_name }}</td>
            <td>
              {{
                service.attended == "0" || service.attended == null
                  ? "Pending..."
                  : service.attended == "1" 
                  ? "Attended"
                  : "--"
              }}
            </td>
            <td>
              <span
                v-if="
                  open_service(
                    service.is_invoice,
                    service.is_paid,
                    cash_bills_behavior
                  )
                "
              >
                <button
                  v-if="service.attended != '1'"
                  @click="showCreateNursingModal(service.id)"
                >
                  Conduct
                </button>
                .
              </span>

              <span
                v-if="
                  !open_service(
                    service.is_invoice,
                    service.is_paid,
                    cash_bills_behavior
                  )
                "
                style="
                  color: black;
                  background-color: pink;
                  padding: 1px;
                  margin: 2px;
                "
              >
                !! Pending Payment !!
              </span>

              <button
                style="background-color: red; color: white"
                v-if="service.attended != '1'"
                @click="removeService(service.id)"
              >
                Delete Service</button
              >.
              <button
                v-if="service.attended == '1'"
                @click="triggerShowResultModal(service.id)"
              >
                View
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- <AddNursingCareModal
    v-if="show_add_nursing_modal"
    @close-add-nursing-modal="hideConductModal"
    :service_id="current_service"
  /> -->
  <AddNursingCareModal
    v-if="show_add_nursing_modal"
    @hide-create-nursing-model="hideCreateNursingModal"
    :service_id="current_service"
  />

  <CreateServiceModal
    v-if="showAddServiceModal"
    :visitId="visit_id"
    @close-add-service-modal="showAddServiceModal = false"
  />

  <vew_nursing_result_modal
    v-if="showResultModal"
    :service_id="current_service"
    @hide-view-result-modal="showResultModal = false"
  />
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import PatientInfo from "../Patients/components/patient_biodata.vue";
import CreateServiceModal from "./add_patient_service_modal.vue";
import AddNursingCareModal from "./nursing/conduct_nursing.vue";
import vew_nursing_result_modal from "./nursing/vew_nursing_result_modal.vue";

import { get_setting } from "../../settings/get_setting.js";
import loader from "../special_clinics/dialysis/loader.vue";
import { open_service } from "../../settings/get_setting.js";

export default {
  name: "NursingServicesPage",
  data() {
    return {
      showResultModal: false,
      show_add_nursing_modal: false,
      showAddServiceModal: false,
      current_service: "",
      services: [],
      visit_id: this.$route.params.visitid,
      patient_id: null,
      cash_bills_behavior: 0,
      loading: false,
    };
  },
  components: {
    AddNursingCareModal,
    PatientInfo,
    CreateServiceModal,
    vew_nursing_result_modal,
    loader,
  },
  methods: {
    open_service,
    navigate_loc(route) {
      window.location.href = route;
    },
    showCreateNursingModal(service_id) {
      this.current_service = service_id;
      this.show_add_nursing_modal = true;
    },
    hideCreateNursingModal() {
      this.current_service = "";
      this.show_add_nursing_modal = false;
    },
    triggerShowResultModal(tid) {
      // console.log(tid);

      this.current_service = tid;
      this.showResultModal = true;
    },

    async fetchServicesForVisit() {
      const url = `services/for-visit/${this.visit_id}` + "/9";
      try {
        const res = await generalApiRequest(url, "GET", {}, 1);
        // console.log(res);

        this.services = res.data;
        const payment_setting = await get_setting("cash_bills_behavior");
        this.cash_bills_behavior = payment_setting.setting_value;
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    },

    async removeService(serviceId) {
      const url = "services/delete/" + serviceId;
      const res = await generalApiRequest(url, "GET", {}, 1);
      if (res) {
        location.reload();
      }
    },

    async mountPastRecords() {
      const url = "get_all_visits_dates";
      const res = await generalApiRequest(
        url,
        "GET",
        { visit_id: this.visit_id },
        1
      );
      this.past_records = res.data;
      if (res.data.length > 0) {
        this.patient_id = res.data[0].patient_id;
      }
    },

    handleShowConductModal(serviceId) {
      this.current_service = serviceId;
      this.show_add_nursing_modal = true;
    },

    hideConductModal() {
      this.show_add_nursing_modal = false;
    },

    showCreatePatientService() {
      this.showAddServiceModal = true;
    },
  },

  mounted() {
    this.mountPastRecords();
    this.fetchServicesForVisit();
  },
};
</script>

<style scoped>
td,
th {
  text-align: center;
  vertical-align: middle;
  padding: 8px;
  border-top: 1px solid #ddd;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  word-wrap: break-word;
}

td {
  padding: 8px;
  border: 1px solid #ddd;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  font-size: 16px;
  overflow: hidden;
}

@media (max-width: 768px) {
  td {
    font-size: 12px;
    padding: 6px;
  }
}

@media (max-width: 480px) {
  td {
    font-size: 10px;
    padding: 4px;
  }

  table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
